import { Injectable } from '@angular/core';

export interface JWTPayload {
  sub: string;
  id: number;
  email: string;
  role: number;
  exp: number;
  iat?: number;
  name?: string;
  [key: string]: unknown; // Permite propiedades adicionales
  user_type?: number;
}

@Injectable({
  providedIn: 'root',
})
export class TokenDecodifierService {
  /**
   * Decodifica un token JWT y retorna su payload
   * @param token Token JWT a decodificar
   * @returns Payload decodificado del token
   * @throws Error si el token es inválido o no tiene el formato correcto
   */
  decode(token: string): JWTPayload {
    if (!token || typeof token !== 'string') {
      throw new Error('Token inválido: el token debe ser una cadena de texto');
    }

    try {
      const parts = token.split('.');

      if (parts.length !== 3) {
        throw new Error(
          'Token inválido: formato incorrecto. Debe tener 3 partes separadas por puntos'
        );
      }
      const base64Url = parts[1];

      // Convertir Base64URL a Base64 estándar
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );

      const payload: JWTPayload = JSON.parse(jsonPayload);

      return payload;
    } catch (error) {
      if (error instanceof Error) {
        throw new Error(`Error al decodificar el token: ${error.message}`);
      }
      throw new Error('Error al decodificar el token: error desconocido');
    }
  }

  /**
   * Obtiene el ID del usuario desde el token decodificado
   * @param token Token JWT
   * @returns ID del usuario o null si no existe
   */
  getUserId(token: string): number | null {
    try {
      const payload = this.decode(token);
      return payload.id || null;
    } catch {
      return null;
    }
  }

  getUserIdSession(): number | null {
    
    const token = localStorage.getItem('accessToken');

    if (!token) return null;

    try {
      const payload = this.decode(token);
      return payload.id || null;
    } catch {
      return null;
    }
  }
}
